import { forwardRef, useState } from 'react';

import Dialog from '@mui/material/Dialog';

import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
// mui icons
import MenuBookIcon from '@mui/icons-material/MenuBook';
import Diapositivas from './Diapositivas';
import { SeccionState } from '../../../../store/slices/seccion';
import { BloqueState } from '../../../../store/slices/bloque';

import CloseIcon from '@mui/icons-material/Close';

const Transition = forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
        },
        ref: React.Ref<unknown>,
    ) {
        return <Slide direction="up" ref={ref} {...props} />;
    }
);

type Props = {
    seccion: SeccionState
    bloque: BloqueState
}

const ModalDiapositiva = ({seccion, bloque}: Props) => {

    const [open, setOpen] = useState(false);
    
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <IconButton
                onClick={() => setOpen(true)}
                color="inherit"
                size="small"
                disabled={seccion?.diapositivas?.length === 0}
            >
                <MenuBookIcon fontSize="inherit" sx={seccion?.diapositivas?.length !== 0 ? { color: '#C29358' } : { color: 'lightgrey' }} />
            </IconButton>
            <Dialog
                fullScreen
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <Diapositivas seccion={seccion} bloque={bloque} />
                <IconButton
                    sx={{
                        position: 'absolute', 
                        right: '25px', 
                        bottom: '25px', 
                        background: 'rgb(128,128,128)',
                        color: 'white',
                        '&:hover': {
                            background: 'rgb(128,128,128,0.6)',
                            color: 'white',
                        },
                        zIndex: 1000
                    }}
                    edge="start"
                    color="error"
                    onClick={handleClose}
                    aria-label="close"
                >
                    <CloseIcon />
                </IconButton>
            </Dialog>
        </div>
    )
}

export default ModalDiapositiva;